"use strict";

var React = require('react');

var startCase = require('lodash/startCase');

var PropTypes = require('prop-types');

var moment = require('moment');

var ProductDetailsWrapper = require('../components/ProductDetailsWrapper');

var Space = require('../components/Space');

var users = require('../../../config/users.json');

var ShineShipping = require('../../../shipping/ShineShipping');

var HorizontalLine = require('../components/HorizontalLine');

var PrintJobPaperTypes = require('../components/PrintJobPaperTypes');

var EstimatedPricing = require('../components/EstimatedPricing'); // const Reimbursement = require('../components/Reimbursement');


var PrintJobColorsUsed = require('../components/PrintJobColorsUsed');

var PrintJobDesignNames = require('../components/PrintJobDesignNames');

var CustomerShippingAddress = require('../components/CustomerShippingAddress');

var PaperComponentDetails = require('../components/PaperComponentDetails');

var EnvelopeComponentDetails = require('../components/EnvelopeComponentDetails');

var RibbonSpoolDetails = require('../components/RibbonSpoolDetails');

var WaxSealDetails = require('../components/WaxSealDetails');

var VellumJacketDetails = require('../components/VellumJacketDetails');

var GlueDotsDetails = require('../components/GlueDotsDetails');

var TapeStripsDetails = require('../components/TapeStripsDetails');

var Highlight = require('../components/Highlight');

var CovidAlert = require('../components/CovidAlert');

var _require = require('../../helpers'),
    isEnvelope = _require.isEnvelope,
    isPaperComponent = _require.isPaperComponent,
    isLetterpressComponent = _require.isLetterpressComponent,
    isShipment = _require.isShipment,
    isRibbon = _require.isRibbon;

var digitalPaperComponents = function digitalPaperComponents(c) {
  return isPaperComponent(c) && !isEnvelope(c) && !isLetterpressComponent(c);
};

function FullOrders(props) {
  var PrintJobs = props.PrintJobs,
      Shipments = props.Shipments,
      user = props.user,
      options = props.options,
      order = props.order;

  if (PrintJobs.length > 1) {
    throw new Error('FullOrders template is meant for 1 print job');
  }

  if (Shipments.length > 1) {
    throw new Error('FullOrders template is meant for 1 shipment');
  }

  var printJob = PrintJobs[0];
  var shipment = Shipments[0];
  var printer = 'printingPlus';
  var componentSettings = options.printers[printer].components;

  if (!componentSettings) {
    throw new Error('componentSettings were undefined');
  }

  var designer = users[printJob.designer_id] || {
    displayName: 'Not set'
  };
  var estimatedArrivalDate;

  if (order) {
    estimatedArrivalDate = ShineShipping.instance().estimateCustomerFacingArrivalDate(shipment, order);
  }

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(PrintJobPaperTypes, {
    variant: "digital",
    printJob: printJob
  })), /*#__PURE__*/React.createElement(Space, {
    n: 2
  }), /*#__PURE__*/React.createElement("span", null, "Designer: ", startCase(designer.displayName)), /*#__PURE__*/React.createElement(Space, {
    n: 1
  }), /*#__PURE__*/React.createElement("span", null, "Sent by: ", startCase(user.displayName)), /*#__PURE__*/React.createElement(Space, {
    n: 2
  }), isShipment(shipment) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, "Customer Shipping Address:", /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement(CustomerShippingAddress, {
    shipment: shipment
  }), /*#__PURE__*/React.createElement(Space, {
    n: 2
  })), /*#__PURE__*/React.createElement("span", null, "Customer Approval Date:", ' ', moment(printJob.approved_on_date).format('ddd MMM DD YYYY')), /*#__PURE__*/React.createElement(Space, {
    n: 2
  }), estimatedArrivalDate && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, "Expected Arrival Date:", ' ', order.is_international ? 'N/A' : moment(estimatedArrivalDate).format('ddd MMM DD YYYY')), /*#__PURE__*/React.createElement(Space, {
    n: 2
  })), isShipment(shipment) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, "Customer Phone Number: ", shipment.telephone), /*#__PURE__*/React.createElement(Space, {
    n: 2
  })), /*#__PURE__*/React.createElement("span", null, "Ship by Date: ", moment(printJob.print_by_date).format('ddd MMM DD YYYY')), /*#__PURE__*/React.createElement(Space, {
    n: 1
  }), isShipment(shipment) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, "Shipping Service: ", shipment.service), /*#__PURE__*/React.createElement(Space, {
    n: 2
  })), /*#__PURE__*/React.createElement(PrintJobPaperTypes, {
    variant: "digital",
    printJob: printJob
  }), /*#__PURE__*/React.createElement(Space, {
    n: 1
  }), /*#__PURE__*/React.createElement(PrintJobColorsUsed, {
    printJob: printJob
  }), /*#__PURE__*/React.createElement(Space, {
    n: 1
  }), /*#__PURE__*/React.createElement(PrintJobDesignNames, {
    printJob: printJob
  }), /*#__PURE__*/React.createElement(Space, {
    n: 2
  }), !printJob.is_reprint && printJob.notes.length ? /*#__PURE__*/React.createElement(React.Fragment, null, printJob.notes.map(function (_ref, index) {
    var text = _ref.text;
    return /*#__PURE__*/React.createElement(Highlight, {
      key: index
    }, "Printer Note: ", text, /*#__PURE__*/React.createElement("br", null));
  }), /*#__PURE__*/React.createElement(Space, {
    n: 1
  })) : null, /*#__PURE__*/React.createElement(CovidAlert, {
    printJob: printJob
  }), isShipment(shipment) && shipment.notes.length ? /*#__PURE__*/React.createElement(React.Fragment, null, shipment.notes.map(function (_ref2, index) {
    var text = _ref2.text;
    return /*#__PURE__*/React.createElement(Highlight, {
      color: "blue",
      key: index
    }, "Notes/Special Instructions: ", text, /*#__PURE__*/React.createElement("br", null));
  }), /*#__PURE__*/React.createElement(Space, {
    n: 1
  })) : null, printJob.is_reprint && printJob.notes.length ? /*#__PURE__*/React.createElement(React.Fragment, null, printJob.notes.map(function (_ref3, index) {
    var text = _ref3.text;
    return /*#__PURE__*/React.createElement(Highlight, {
      key: index
    }, "REPRINT NOTES: ", text, /*#__PURE__*/React.createElement("br", null));
  }), /*#__PURE__*/React.createElement(Space, {
    n: 1
  })) : null, /*#__PURE__*/React.createElement(ProductDetailsWrapper, {
    printJob: printJob,
    filterFunction: isRibbon,
    RenderComponent: RibbonSpoolDetails,
    options: options,
    componentSettings: componentSettings,
    printer: printer
  }), /*#__PURE__*/React.createElement(WaxSealDetails, {
    options: options,
    componentSettings: componentSettings,
    printer: printer,
    products: printJob.products
  }, /*#__PURE__*/React.createElement(Space, {
    n: 1
  })), /*#__PURE__*/React.createElement(VellumJacketDetails, {
    options: options,
    componentSettings: componentSettings,
    printer: printer,
    products: printJob.products
  }, /*#__PURE__*/React.createElement(Space, {
    n: 1
  })), /*#__PURE__*/React.createElement(GlueDotsDetails, {
    options: options,
    componentSettings: componentSettings,
    printer: printer,
    products: printJob.products
  }, /*#__PURE__*/React.createElement(Space, {
    n: 1
  })), /*#__PURE__*/React.createElement(TapeStripsDetails, {
    options: options,
    componentSettings: componentSettings,
    printer: printer,
    products: printJob.products
  }, /*#__PURE__*/React.createElement(Space, {
    n: 1
  })), printJob.has_envelopes ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Highlight, null, "THIS ORDER CONTAINS ENVELOPES"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null)) : null, /*#__PURE__*/React.createElement(ProductDetailsWrapper, {
    printJob: printJob,
    filterFunction: digitalPaperComponents,
    RenderComponent: PaperComponentDetails,
    options: options,
    componentSettings: componentSettings,
    printer: printer
  }), /*#__PURE__*/React.createElement(HorizontalLine, null), /*#__PURE__*/React.createElement(ProductDetailsWrapper, {
    printJob: printJob,
    filterFunction: isEnvelope,
    RenderComponent: EnvelopeComponentDetails,
    options: options,
    componentSettings: componentSettings,
    printer: printer
  }, /*#__PURE__*/React.createElement(HorizontalLine, null), /*#__PURE__*/React.createElement(Space, {
    n: 1
  })), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, "Estimated Pricing"), /*#__PURE__*/React.createElement(Space, {
    n: 1
  }), printJob.is_for_covid ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, "COVID", /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement(Space, {
    n: 1
  })) : null, ['PRINTING_ISSUES_PRODUCTION_ORIGINAL', 'PRINTING_ISSUES_PRODUCTION', 'MISSING_PIECES'].includes(printJob.reprint_reason) ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, "No charge, printing/finishing issue on original order"), /*#__PURE__*/React.createElement(Highlight, null, "(INSERT ISSUE HERE)"), /*#__PURE__*/React.createElement(Highlight, null, "Need to be reimbursed $_______ for stock and $_______ for shipping.")) : /*#__PURE__*/React.createElement(EstimatedPricing, {
    options: options,
    componentSettings: componentSettings,
    printer: printer,
    variant: "FullOrders",
    printJob: printJob
  }), /*#__PURE__*/React.createElement(Space, {
    n: 1
  }), /*#__PURE__*/React.createElement(HorizontalLine, null), /*#__PURE__*/React.createElement(Space, {
    n: 1
  })), /*#__PURE__*/React.createElement(Space, {
    n: 1
  }));
}

FullOrders.defaultProps = {};
FullOrders.propTypes = {
  PrintJobs: PropTypes.array.isRequired,
  Shipments: PropTypes.array.isRequired,
  order: PropTypes.object,
  user: PropTypes.shape({
    displayName: PropTypes.string.isRequired
  }).isRequired,
  options: PropTypes.object
};
module.exports = FullOrders;